import { changePreview, changeMoreImageMode } from '../../../../../../../redux/product/product.actions';
export default function (dispatch) {
  return {
    onChangeView: index => {
      if (index === null) {
        return;
      }
      dispatch(changePreview(index));
    },
    onMoreImageModeChange: () => {
      dispatch(changeMoreImageMode());
    }
  };
}